var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableware(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2652 5.14285C21.2397 5.14285 19.5918 6.79079 19.5918 8.81631V12.7347C19.5918 13.1404 19.9208 13.4694 20.3265 13.4694H22.5305V18.1224C22.5305 18.5281 22.8595 18.8571 23.2652 18.8571C23.6709 18.8571 23.9999 18.5282 23.9999 18.1224V5.87752C23.9999 5.47177 23.671 5.14285 23.2652 5.14285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67345 5.14285C3.2677 5.14285 2.93878 5.47173 2.93878 5.87748V8.81593C2.93878 9.22131 2.6092 9.55102 2.20402 9.55102C1.79897 9.55102 1.46939 9.22131 1.46939 8.81602V5.87748C1.46939 5.47173 1.14042 5.14285 0.734719 5.14285C0.328969 5.14285 0 5.47177 0 5.87752V8.81607C0 9.77396 0.61425 10.5907 1.46939 10.894L1.46934 18.1225C1.46934 18.5282 1.79831 18.8572 2.20402 18.8572C2.60972 18.8572 2.93873 18.5282 2.93873 18.1225L2.93878 10.894C3.79392 10.5907 4.40817 9.77387 4.40817 8.81598V5.87752C4.40817 5.47177 4.0792 5.14285 3.67345 5.14285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7541 10.0408C10.6738 10.0408 9.79492 10.9197 9.79492 12C9.79492 13.0803 10.6738 13.9592 11.7541 13.9592C12.8344 13.9592 13.7133 13.0803 13.7133 12C13.7133 10.9197 12.8344 10.0408 11.7541 10.0408Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7541 5.6326C8.24309 5.6326 5.38672 8.48897 5.38672 12C5.38672 15.5109 8.24305 18.3674 11.7541 18.3674C15.2651 18.3674 18.1214 15.5109 18.1214 12C18.1214 8.48902 15.2651 5.6326 11.7541 5.6326ZM11.7541 15.4286C9.86352 15.4286 8.3255 13.8905 8.3255 12C8.3255 10.1094 9.86352 8.57143 11.7541 8.57143C13.6446 8.57143 15.1827 10.1094 15.1827 12C15.1826 13.8905 13.6446 15.4286 11.7541 15.4286Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableware);
export default __webpack_public_path__ + "static/media/tableware.e644ba2778f3c6e2688b3b2a62b6f1ce.svg";
export { ForwardRef as ReactComponent };